export enum EventModalMode {
  view = 0,
  create = 1,
  edit = 2,
}
